function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.2463 10.5L19.8454 1.90092C19.9414 1.80539 20 1.67344 20 1.52778C20 1.23644 19.7641 1 19.4722 1C19.3271 1 19.1951 1.05911 19.0991 1.15464L10.5 9.75372L1.90092 1.15464C1.80539 1.05911 1.67344 1 1.52778 1C1.23592 1 1 1.23644 1 1.52778C1 1.67344 1.05858 1.80539 1.15464 1.90144L9.75372 10.5L1.15464 19.0991C1.05858 19.1946 1 19.3266 1 19.4722C1 19.7641 1.23592 20 1.52778 20C1.67344 20 1.80539 19.9409 1.90092 19.8454L10.5 11.2463L19.0991 19.8454C19.1951 19.9409 19.3271 20 19.4722 20C19.7641 20 20 19.7641 20 19.4722C20 19.3266 19.9414 19.1946 19.8454 19.0991L11.2463 10.5Z",
  fill: "#EBEBEB",
  stroke: "#8D8EA7"
});

var SvgCross = function SvgCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross.43979bd2.svg";
export { ForwardRef as ReactComponent };